import React from 'react';

import HeroImageTemplate from './template';

const HeroImage = () => {
  return <HeroImageTemplate />;
};

export default HeroImage;
